import { useCallback } from 'react';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';

export const useHighLevelProgramLogic = ({ api, setMaxLevel, setIsPayloadReady, widgetViewMode }) => {
    const isPayloadReady = () => {
        const currentPayload = api.highLevelProgram.payload;
        if (!currentPayload) return;
        if (
            currentPayload.id === undefined ||
            currentPayload.id.length === 0 ||
            currentPayload.id[0] === undefined ||
            currentPayload.id[0] === null
        ) {
            return;
        }
        setIsPayloadReady && setIsPayloadReady(true);
    };

    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });
    const handleHighLevelFilter = useCallback((value) => {
        setMaxLevel(value);
    }, []);

    const noDataText =
        api.highLevelProgram.instance.data?.data === null
            ? 'Not applicable with the applied filter'
            : 'No data to display';

    return {
        logic: {
            noDataText,
            handleHighLevelFilter,
        },
    };
};
